import { ContentPageProps } from "../../content/ContentPage";
import PageComponent from "../../pages/website/Page";
import {
  Attendant,
  Configuration,
  Page,
  Photo,
} from "../../resources/modelTypes";
import { getPhotoByPk, RootState } from "../../resources/reduxTypes";
import AttendantComponent from "./Attendant";
import { css } from "@emotion/react";
import { theme, styleUtils } from "@minted/minted-components";
import React, { Fragment } from "react";
import { connect } from "react-redux";

const grid = (layout) => css`
  ${theme.media.greaterThan(theme.breakpoints.medium)(`
    display: flex;
    flex-wrap: wrap;
    gap: ${layout === "multi" ? "unset" : styleUtils.rem(70)};
    & > * {
      width: ${layout === "multi" ? "calc(5/12 * 100%)" : "100%"};
    };
  `)}
`;

const spacerStyle = css`
  flex: 1;
`;

export type WeddingPartyProps = {
  attendants: Attendant[];
  configuration: Configuration;
  id: string;
  pageData: Page;
  title: string;
};

type WeddingPartyPropsWithRedux = {
  fullPhoto: Photo | null;
} & WeddingPartyProps;

const WeddingParty = ({
  attendants,
  configuration,
  fullPhoto,
  id,
  pageData,
  title,
}: WeddingPartyPropsWithRedux) => {
  const pageDataImageOverride: Page = {
    ...pageData,
    image: pageData.image || fullPhoto?.original || null,
  };

  return (
    <PageComponent
      id={id}
      pageData={pageDataImageOverride}
      removeSpacing
      title={title}
    >
      <div css={grid(configuration.pageLayout)}>
        {attendants.map((item, index) => (
          <Fragment key={`${item.id}Attendant`}>
            <AttendantComponent
              configuration={configuration}
              description={item.bio}
              {...item}
            />

            {configuration.pageLayout === "multi" && index % 2 === 0 ? (
              <div css={spacerStyle} key={`spacer-${index}`} />
            ) : null}
          </Fragment>
        ))}
      </div>
    </PageComponent>
  );
};

const mapStateToProps = (state: RootState, props: ContentPageProps) => ({
  fullPhoto: getPhotoByPk(state, props.pageData.photo),
});

export default connect(mapStateToProps)(
  WeddingParty,
) as unknown as React.FC<WeddingPartyProps>;
